import { Component, Element, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-hotspot-item',
  styleUrl: 'hotspot-item.css',
  shadow: true,
})
export class HotspotItem {
  @Element() host: HTMLElement;

  @Prop() x           : number = 0;
  @Prop() y           : number = 0;
  @Prop() width       : number = 0;
  @Prop() height      : number = 0;
  @Prop() popupWidth  : number = 400;
  @Prop() popupAnchor : string = 'top-left';

  iconSVG = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>

  toggleOverlay = () => {
    let host = this.host;
    let parent = host.parentNode;
    let allHotspots = parent.querySelectorAll('cradlepoint-hotspot-item');
    let card = host.querySelector('cradlepoint-card-simple-text') as HTMLElement;
    let popup = host.shadowRoot.querySelector('.popup') as HTMLElement;

    if (host.dataset.active == 'false') {
      allHotspots.forEach((hotspot: HTMLElement) => {
        hotspot.dataset.active = 'false';
      });

      host.dataset.active = 'true';
      popup.style.width = `${card.clientWidth}px`;
      popup.style.height = `${card.clientHeight}px`;
    } else {
      host.dataset.active = 'false';
    }

  }

  render() {
    return (
      <Host
        style={{
          left: `${this.x}cqw`,
          top: `${this.y}cqw`,
          width: `${this.width}cqw`,
          height: `${this.height}cqw`,
        }}
        onMouseEnter={this.toggleOverlay}
        onMouseLeave={this.toggleOverlay}
        data-active="false"
      >
        <div class="overlay">
          <div class={`popup ${this.popupAnchor}`} style={{minWidth:`${this.popupWidth}px`}}>
            <slot></slot>
          </div>
        </div>
      </Host>
    );
  }

}
